import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {SwiperOptions} from "swiper/types";

@Component({
  selector: 'app-thx',
  templateUrl: './thx.component.html',
  styleUrls: ['./thx.component.css']
})
export class ThxComponent implements OnInit {

  thx_type: 'submit'|'delete'|'' = '';
  swiperOptions: SwiperOptions = {
    slidesPerView: 'auto',
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      clickable: true,
      el: '.ra-thx-swiper-pagination',
      type: 'bullets',
    },
    // Navigation arrows
    navigation: {
      nextEl: '.ra-thx-swiper-button-next',
      prevEl: '.ra-thx-swiper-button-prev',
    }
  }

  constructor(private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit(): void {
    // console.log(this.route.snapshot.params.type);
    let thx_type = this.route.snapshot.params.type;
    if(['submit','delete'].indexOf(thx_type)===-1) {
      console.warn('unknown type', thx_type);
      this.router.navigate(['home']);
      return;
    }
    this.thx_type = thx_type;
  }

}
